// app/javascript/controllers/menu_controller.js

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.toggleClass = "hidden";
  }

  toggle() {
    this.menuTarget.classList.toggle(this.toggleClass);
  }
}
